import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import MatrizLandingMobile from './MatrizLandingMobile';
import MatrizLandingDesktop from './MatrizLandingDesktop';

function MatrizLanding({ app, config }) {
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });
    return isMobile ? <MatrizLandingMobile app={app} config={config} />
        : <MatrizLandingDesktop app={app} config={config} />;

    // return <MatrizLandingDesktop app={app} config={config} />;
}

MatrizLanding.defaultProps = {
    app: null,
    config: {}
};

MatrizLanding.propTypes = {
    app: PropTypes.object,
    config: PropTypes.object
};

export default MatrizLanding;
